/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // Npm: Apollo client for handling graphql request.

/*
 * GRAPHS
 */
const Index = gql`
  mutation MyMutation($sellerFormId: ID!) {
    SellerFormApprove(sellerFormId: $sellerFormId) {
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
